(function() {
  function getNextMidnight() {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    return midnight;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  window.SEInitCartDailyCountdown = function(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var countdowns = root.querySelectorAll('[data-cart-daily-countdown]');

    countdowns.forEach(function(countdown) {
      var timeElement = countdown.querySelector('[data-cart-daily-countdown-time]');
      if (!timeElement) return;

      if (countdown.__seCartDailyCountdownInterval) {
        clearInterval(countdown.__seCartDailyCountdownInterval);
      }

      function updateCountdown() {
        if (!document.documentElement.contains(countdown)) {
          clearInterval(countdown.__seCartDailyCountdownInterval);
          countdown.__seCartDailyCountdownInterval = null;
          return;
        }

        var now = new Date();
        var target = getNextMidnight();
        var diff = target.getTime() - now.getTime();

        if (diff <= 0) {
          target = getNextMidnight();
          diff = target.getTime() - now.getTime();
        }

        var totalSeconds = Math.max(0, Math.floor(diff / 1000));
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        timeElement.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
        countdown.classList.add('is-active');
      }

      updateCountdown();
      countdown.__seCartDailyCountdownInterval = window.setInterval(updateCountdown, 1000);
    });
  };

  function initCartDailyCountdown(scope) {
    if (window.SEInitCartDailyCountdown) {
      window.SEInitCartDailyCountdown(scope || document);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCartDailyCountdown(document);
    });
  } else {
    initCartDailyCountdown(document);
  }

  document.addEventListener('cart:updated', function() {
    initCartDailyCountdown(document);
  });

  document.addEventListener('cartdrawer:opened', function() {
    initCartDailyCountdown(document);
  });

  document.addEventListener('ajaxProduct:added', function() {
    initCartDailyCountdown(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initCartDailyCountdown(event.target || document);
  });
})();

class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        if (window.SEInitCartDailyCountdown) {
          window.SEInitCartDailyCountdown(document.getElementById('mini-cart'));
        }

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();

    if (window.SEInitCartDailyCountdown) {
      window.SEInitCartDailyCountdown(this);
    }
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    if (window.SEInitCartDailyCountdown) {
      window.SEInitCartDailyCountdown(this);
    }

    document.dispatchEvent(new CustomEvent('cartdrawer:updated'));
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
